import {ColorSource, Container, Graphics, Sprite, Text, TextStyle, Texture} from "pixi.js";
import {DRect} from "src/app/binst/primitives/drawable-rect";
import {PixiObject} from "../primitives/pixi-object";
import {BlueprintContext} from "../../../world/cyanprints/i-blueprint-context";
import {Rect, RectConstructor} from "../../../primitives/rect";


export function bodyStyle(fill: ColorSource, width: number, fontSize: number, useSolid: boolean): TextStyle {
    const fontFamily = useSolid ? ["fa-solid"] : ["fa-regular"]
    const textStyle = new TextStyle({
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeight: "normal",
        fill: fill,
        wordWrapWidth: width,
        breakWords: true,
        align: "center",
        padding: 2
    });
    return textStyle;
}

type IconDrawableConfig = {
    text: string;
    width: number;
    clickableRadius?:number;
    colour: ColorSource;
    useSolidIcon: boolean;
    blueprintContext: BlueprintContext;
}

export class IconButtonDrawable extends PixiObject {
    blueprintContext: BlueprintContext;
    pixiText: Text;
    override config: IconDrawableConfig
    graphics: Graphics

    constructor(config: IconDrawableConfig & {}) {
        super({id: "icon-button-" + config.text.slice(0, 10)});
        this.blueprintContext = config.blueprintContext;
        this.config = config;
        this.build();
        this.touchPrimitive.showPointerCursor = true
    }

    updateBtn(text: string, useSolid: boolean) {
        this.config.text = text;
        this.config.useSolidIcon = useSolid;
        this.build();
    }

    private build() {
        if (this.pixiText) {
            this.sprite.removeChild(this.pixiText);
            this.pixiText.destroy();
        }
        if (!this.graphics) {
            this.graphics = new Graphics({});
            let radius = this.config.width / 2;
            if (this.config.clickableRadius) {
                radius = this.config.clickableRadius;
            }
            this.graphics
                .ellipse(this.config.width/2, this.config.width/2, radius, radius)
                .fill({color: "#575757"})
            this.graphics.alpha = 0;
            this.sprite.addChild(this.graphics);
        }
        this.pixiText = new Text({
            text: this.config.text,
            // resolution: 2,
            style: bodyStyle(this.config.colour, this.config.width, this.config.width, this.config.useSolidIcon)
        });
        this.pixiText.x = 1.5;
        this.sprite.addChild(this.pixiText);
        this.updateTouchBounds()
    }

    override setupDefaultInteractions() {
        // Click on image to view full size
        this.touchPrimitive.onPressed((pt) => {
            console.log('Icon button clicked:', this.id);
            // Dispatch action to open image viewer
            return false; // Stop propagation
        });
        this.touchPrimitive.onPressed( (pt) => {
            // this.pixiText.alpha = 0.5;
            this.graphics.alpha = 0.3
            this.requestRender()
            return true; // Stop propagation
        });
        this.touchPrimitive.onReleased( (pt) => {
            this.pixiText.alpha = 1;
            this.graphics.alpha = 0;
            this.requestRender()
            return true; // Stop propagation
        });
        this.touchPrimitive.onHover((pt) => {
            this.graphics.alpha = 1
            this.requestRender()
            return false
        })
        this.touchPrimitive.onHoverNear((pt) => {
            this.graphics.alpha = 0
            this.requestRender()
            return false
        })
    }

    addDebugRect(width, height) {
        const graphics = new Graphics({});
        const rect = new DRect({
            left: 0,
            top: 0,
            right: width,
            bottom: height,
            roundness: 5,
            colour: "rgba(58,52,49,0.53)",
        });
        rect.render(graphics);
        this.sprite.addChild(graphics);
    }
}

